import * as loginActions from '../login/actions';
import * as categoriesActions from '../categories/actions';
import * as cashboxesActions from '../cashboxes/actions';
import {Record, OrderedMap, fromJS, List} from 'immutable';

const State = Record({
    cashboxes: OrderedMap(),
    defaultCashbox: null,
    selectedCashbox: null,
    allOrganizationCashboxes: List()
});

const CASHBOXES = 'cashboxes';
const DEFAULT_CASHBOX = 'defaultCashbox';
const SELECTED_CASHBOX = 'selectedCashbox';
const ALL_ORGANIZATION_CASHBOXES = 'allOrganizationCashboxes';

const cashboxesReducer = (state = new State(), action) => {

    switch (action.type) {

        case cashboxesActions.FETCH_ALL_ORGANIZATION_CASHBOXES_SUCCESS: {
            const data = action.payload.data;
            return state.set(ALL_ORGANIZATION_CASHBOXES, fromJS(data));
        }

        case categoriesActions.FETCH_INIT_APP_SUCCESS: {
            const {cashboxes} = action.payload.data;
            let cashboxesMap = OrderedMap();

            fromJS(cashboxes)
                .sort(c => c.get('id'))
                .filter(c => c.getIn(['currency', 'name']) === 'CZK' && !!c.get('fiscalize'))
                .forEach(c => {
                    cashboxesMap = cashboxesMap.set(c.get('id'), c);
                });

            fromJS(cashboxes)
                .sort(c => c.get('id'))
                .filter(c => c.getIn(['currency', 'name']) === 'CZK' && !c.get('fiscalize'))
                .forEach(c => {
                    cashboxesMap = cashboxesMap.set(c.get('id'), c);
                });

            let defaultCashbox;
            const defaultCashboxes = cashboxesMap.filter(c => c.get('type') === 'CASH');
            if (defaultCashboxes.size > 0) {
                defaultCashbox = defaultCashboxes.first();
            } else {
                defaultCashbox = cashboxesMap.filter(c => c.get('type') === 'CASH').first();
            }

            return state
                .set(CASHBOXES, cashboxesMap)
                .set(DEFAULT_CASHBOX, defaultCashbox)
                .set(SELECTED_CASHBOX, defaultCashbox);
        }

        case loginActions.API_LOGOUT: {
            return state.set(CASHBOXES, OrderedMap());
        }

        case cashboxesActions.RESET_SELECTED_CASHBOX_TO_DEFAULT: {
            return state.set(SELECTED_CASHBOX, state.get(DEFAULT_CASHBOX));
        }

        case cashboxesActions.SELECT_CASHBOX: {
            return state.set(SELECTED_CASHBOX, state.getIn([CASHBOXES, action.payload.id]));
        }
    }

    return state;
};

export default cashboxesReducer;



// WEBPACK FOOTER //
// ./src/common/cashboxes/reducer.js